import request from 'axios';
import idx from 'idx';
import { setBannerError } from 'error';
import moment from 'moment';

/* ACTIONS
================================================================================================ */
const FETCH_MASS_EMAILS = 'crowdspring/admin/FETCH_MASS_EMAILS';
const FETCH_MASS_EMAILS_SUCCESS = 'crowdspring/admin/FETCH_MASS_EMAILS_SUCCESS';

/* INITIAL STATES
================================================================================================ */
export const initialState = {
  massEmails: []
};

/* REDUCERS
================================================================================================ */
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_MASS_EMAILS_SUCCESS:
      return {
        ...state,
        massEmails: action.payload
      };
    default:
      return state;
  }
}

const processDate = (dateString) => {
  const date = moment(dateString, 'MM/DD/YYYY HH:mm');
  if (date.isValid()) {
    return date.format();
  }
  window.alert('The date you provided is not valid.');
}

export const adminActions = (action, formData, method="patch") => (dispatch) => {
  const data = { ...formData };

  let url = `/api/v1/radmin/reporting/${action}/`;

  if (action === 'conversion_track_by_utm_medium_and_date' && data.newer_than) {
    data.newer_than = processDate(data.newer_than);
    if (!data.newer_than) {
      return Promise.reject();
    }
  } else if (action === 'conversion_track_by_ip') {
    data.ips = data.ips.split('\n');
  } else if (action === 'conversion_track_by_email') {
    data.emails = data.emails.split('\n');
  } else if (
    [
      'conversion_track_focus_groups_by_date', 'track_lead_sources_over_time',
      'conversion_track_by_marketing_segment', 'additional_projects'
    ].includes(action)
  ) {
    data.start = processDate(data.start);
    if (!data.start) {
      return Promise.reject();
    }

    data.end = processDate(data.end);
    if (!data.end) {
      return Promise.reject();
    }
  }

  const promise = request[method](url, data);

  promise.catch((err) => {
    const errorMsg = idx(err, _ => _.data.message) || 'Unknown error';
    dispatch(setBannerError('Error performing action', errorMsg))
  });

  return promise;
};
